module.exports = __webpack_public_path__ + "static/img/icon-save.b37525aa.svg";